import React from 'react'
import ThemeWrapperContainer from './ThemeWrapperContainer'

const ThemeWrapper = props => (
  <ThemeWrapperContainer data-test="component-theme-wrapper-container" {...props} />
)
export default ThemeWrapper
